import common from "@store/theme/common";
import { setThemeCollection } from "@store/theme/config";
import horizon from "@store/theme/horizon";

const themes = { common, horizon };

export type ThemeName = keyof typeof themes;
export default setThemeCollection<ThemeName>(themes, "common");
